import { useEffect, useState } from "react";
import { toast } from "sonner";
import { getAccounts, createAccount, deleteAccount, getClients } from "./opsApi";
import { useOpsAuth } from "./OpsAuthContext";
import { Plus, Trash2 } from "lucide-react";

const PLATFORMS = ["Instagram", "TikTok", "YouTube", "Facebook", "X (Twitter)"];
const OAUTH = [["Instagram", "#E1306C"], ["TikTok", "#000000"], ["YouTube", "#FF0000"]];
const inp = "w-full rounded-lg border border-white/10 bg-white/5 px-3 py-2 text-sm text-white outline-none focus:border-[#AC3333]";

export default function OpsAccounts() {
  const { user } = useOpsAuth();
  const isSuper = user?.role === "super_admin";
  const [rows, setRows] = useState([]);
  const [clients, setClients] = useState([]);
  const [f, setF] = useState({ client_id: "", platform: PLATFORMS[0], handle: "" });

  const load = () => { getAccounts().then(setRows).catch(() => {}); getClients().then(setClients).catch(() => {}); };
  useEffect(() => { load(); }, []);

  const add = async () => {
    if (!f.client_id || !f.handle.trim()) { toast.error("Elige cliente y handle"); return; }
    try { await createAccount(f); setF({ ...f, handle: "" }); load(); toast.success("Cuenta añadida"); }
    catch (e) { toast.error(e?.response?.data?.detail || "Error"); }
  };
  const cname = (id) => clients.find((c) => c.id === id)?.name || "—";

  return (
    <div data-testid="ops-accounts">
      <h2 className="mb-5 font-serif text-2xl font-bold text-white">Cuentas de Redes</h2>
      <div className="mb-6 rounded-2xl border border-white/10 bg-[#241010] p-4">
        <div className="mb-3 text-xs font-semibold uppercase tracking-wider text-white/50">Conectar con OAuth oficial</div>
        <div className="flex flex-wrap gap-2">
          {OAUTH.map(([name, color]) => (
            <button key={name} data-testid={`ops-oauth-${name.toLowerCase()}`} onClick={() => toast.info(`Conexión con ${name} disponible en Fase 2 (requiere credenciales de desarrollador).`)} className="flex items-center gap-2 rounded-lg border border-white/15 px-4 py-2 text-sm font-semibold text-white hover:border-white/40">
              <span className="h-2.5 w-2.5 rounded-full" style={{ background: color }} /> Conectar {name}
            </button>
          ))}
        </div>
        <p className="mt-2 text-[11px] text-white/40">Próximamente: guardará access_token y refresh_token cifrados por cliente.</p>
      </div>
      <div className="mb-6 flex flex-wrap items-end gap-3 rounded-2xl border border-white/10 bg-[#241010] p-4">
        <div className="min-w-[150px] flex-1"><label className="mb-1 block text-xs text-white/50">Cliente</label>
          <select data-testid="ops-acc-client" value={f.client_id} onChange={(e) => setF({ ...f, client_id: e.target.value })} className={inp}><option value="">—</option>{clients.map((c) => <option key={c.id} value={c.id}>{c.name}</option>)}</select></div>
        <div className="min-w-[130px]"><label className="mb-1 block text-xs text-white/50">Red</label>
          <select data-testid="ops-acc-platform" value={f.platform} onChange={(e) => setF({ ...f, platform: e.target.value })} className={inp}>{PLATFORMS.map((p) => <option key={p}>{p}</option>)}</select></div>
        <div className="min-w-[150px] flex-1"><label className="mb-1 block text-xs text-white/50">Usuario / handle</label>
          <input data-testid="ops-acc-handle" value={f.handle} onChange={(e) => setF({ ...f, handle: e.target.value })} className={inp} placeholder="@usuario" /></div>
        <button data-testid="ops-acc-add" onClick={add} className="flex items-center gap-1.5 rounded-lg bg-[#AC3333] px-4 py-2 text-sm font-semibold text-white hover:bg-[#FF0505]"><Plus className="h-4 w-4" /> Añadir</button>
      </div>
      <div className="overflow-hidden rounded-2xl border border-white/10">
        <table className="w-full text-sm">
          <thead className="bg-white/5 text-left text-xs uppercase tracking-wider text-white/40"><tr><th className="px-4 py-2">Cliente</th><th className="px-4 py-2">Red</th><th className="px-4 py-2">Handle</th><th className="px-4 py-2">Conexión</th><th className="px-4 py-2"></th></tr></thead>
          <tbody>
            {rows.map((a) => (
              <tr key={a.id} data-testid={`ops-acc-${a.id}`} className="border-t border-white/5 text-white/80">
                <td className="px-4 py-2">{cname(a.client_id)}</td><td className="px-4 py-2">{a.platform}</td><td className="px-4 py-2">{a.handle}</td>
                <td className="px-4 py-2"><span className="rounded-full bg-amber-500/15 px-2 py-0.5 text-[11px] text-amber-300">Sin conectar (Fase 2)</span></td>
                <td className="px-4 py-2 text-right">{isSuper && <button data-testid={`ops-acc-del-${a.id}`} onClick={() => { deleteAccount(a.id).then(load); }} className="text-red-300"><Trash2 className="h-4 w-4" /></button>}</td>
              </tr>
            ))}
            {rows.length === 0 && <tr><td colSpan={5} className="px-4 py-6 text-center text-white/40">Aún no hay cuentas.</td></tr>}
          </tbody>
        </table>
      </div>
    </div>
  );
}
